import React from 'react'
import styles from './index.module.css'

type Props = {
  artwork: string | null | undefined
}

/**
 * Artwork display component for metadata copying interface
 * Shows artwork thumbnail or placeholder with sound wave pattern when no artwork exists
 * @param artwork - URL of the artwork image to display
 */
const CopyMetadataArtwork = ({ artwork }: Props) => {
  return !artwork ? (
    <div className={styles.copyMetadataArtwork}>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="3.5"
          fill="#f4f4f4"
          stroke="#42526e"
          strokeDasharray="2 2"
        />
        <path
          d="M10.5 5.5H9.5V14.5H10.5V5.5ZM7.5 6.5H8.5V13.5H7.5V6.5ZM11.5 7H12.5V13H11.5V7ZM5.5 8H6.5V12H5.5V8ZM14.5 8.5H13.5V11H14.5V8.5Z"
          fill="#ddd"
        />
        <path d="M2 18L18 2" stroke="#42526e" strokeDasharray="2 2" />
      </svg>
    </div>
  ) : (
    <div
      className={styles.copyMetadataArtwork}
      style={{
        backgroundImage: `url("${artwork}")`,
      }}
    />
  )
}

export default React.memo<Props>(CopyMetadataArtwork)
